import cls from 'classnames';
import { Link } from 'react-router-dom';
import type { FC, PropsWithChildren } from 'react';
import s from './index.module.scss';

type Props = {
  to?: string;
  href?: string;
  title?: string;
  className?: string;
};

const IconLink: FC<PropsWithChildren<Props>> = ({ to, href, title, className, children }) => {
  if (to) {
    return (
      <Link to={to} title={title} className={cls(className, s.link)}>
        {children}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      title={title}
      className={cls(className, s.link)}
    >
      {children}
    </a>
  );
};

export default IconLink;
